var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"space-y-6"},_vm._l((_vm.groupedEstimates),function(estimateGroup){return _c('estimates-old-list-group',{key:estimateGroup.uuid,attrs:{"estimate-group":estimateGroup}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }